module.exports = __webpack_public_path__ + "static/img/tai-sui-dian.ffd90ee.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/tai-sui-dian.jpeg
// module id = 2gLp
// module chunks = 1